export interface MapPoint {
  lat: number;
  lng: number;
}

/** Reject missing points, out-of-range coordinates and the common unset (0, 0) sentinel. */
export function usableMapPoint(point: MapPoint | null | undefined): point is MapPoint {
  return (
    !!point &&
    Number.isFinite(point.lat) &&
    Number.isFinite(point.lng) &&
    Math.abs(point.lat) <= 85.051129 &&
    Math.abs(point.lng) <= 180 &&
    (point.lat !== 0 || point.lng !== 0)
  );
}

export interface MapLocation {
  locationId: string;
  center: MapPoint | null;
}
